module.exports = __webpack_public_path__ + "img/logo_small.38d6c2c0.png";